import { render, staticRenderFns } from "./ProductProductActionResource.vue?vue&type=template&id=da6d7fa6&"
import script from "./ProductProductActionResource.vue?vue&type=script&lang=js&"
export * from "./ProductProductActionResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports